import Dispatcher from './Dispatcher';
import ActionTypes from './ActionTypes';
import checkStatus from '../utils/checkStatus';
import api from '../utils/api';
import dispatchHttpError from '../utils/dispatchHttpError';
import JwtStore from './JwtStore'

export default {
  search(query) {
    return fetch(api(`search?query=${query}`), {
      headers: {
        'Authorization': `Bearer ${JwtStore.getToken()}`,
        'Accept': 'application/json'
      },
    })
      .then(checkStatus)
      .then(response => response.json())
      .then(response => {
        Dispatcher.dispatch({
          actionType: ActionTypes.SEARCH_STORE_SEARCH_COMPLETED,
          results: response.data
        });
      })
      .catch(dispatchHttpError);
  }
}
